import CssBaseline from '@mui/material/CssBaseline';
import {
  adaptV4Theme,
  createTheme,
  StyledEngineProvider,
  ThemeProvider
} from '@mui/material/styles';
import { useCurrentTenant, useErrorContext } from '@qpr/client-library';
import React, { ReactNode, useEffect, useState } from 'react';
import qprLight from './light/qpr-light2';
import initialState from './qpr-theme-provider-state';
import createQprThemeProviderViewModel, {
  QprThemeProviderViewModelType
} from './qpr-theme-provider-view-model';

interface QprThemeProviderProps {
  children: ReactNode;
  themeName?: string;
}

const QprThemeProvider = ({ children, themeName }: QprThemeProviderProps) => {
  const [data, setData] = useState(initialState);
  const [inited, setInited] = useState(false);
  const { setError } = useErrorContext();

  const { symbol } = useCurrentTenant();
  const viewModel: QprThemeProviderViewModelType = createQprThemeProviderViewModel(
    symbol,
    themeName
  );
  useEffect(() => {
    const initData = async () => {
      setError(null);
      const gotData = await viewModel.getData();
      setData(gotData);
      setInited(true);
      if (gotData.error?.message) setError(gotData.error);
    };
    initData();
  }, []);
  const myTheme = data.themes?.find(theme => theme?.name === themeName) || data.themes[0];

  const myThemeOptions = myTheme?.themeOptions ?? qprLight;

  const refinedOptions = {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
      }
    },
    ...myThemeOptions,
    typography: { ...myThemeOptions.typography, htmlFontSize: 10 }
  };

  const theme = createTheme(adaptV4Theme(refinedOptions));

  return inited ? (
    <StyledEngineProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <>{children}</>
      </ThemeProvider>
    </StyledEngineProvider>
  ) : null;
};

export default QprThemeProvider;
